import { render, staticRenderFns } from "./exportInfoSearch.vue?vue&type=template&id=2ae81764&"
import script from "./exportInfoSearch.vue?vue&type=script&lang=js&"
export * from "./exportInfoSearch.vue?vue&type=script&lang=js&"
import style0 from "./exportInfoSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports